<template>
    <Card :class="levelUpdate.oldLevel !== levelUpdate.newLevel
        ? 'bg-gradient-to-r! from-blue-50 via-indigo-50 to-purple-50 dark:from-blue-900/20 dark:via-indigo-900/20 dark:to-purple-900/20 border! border-blue-300 dark:border-blue-500 ring-2 ring-blue-300 dark:ring-blue-500 ring-opacity-50 shadow-lg! shadow-blue-200/50 dark:shadow-blue-500/20'
        : 'bg-gradient-to-r! from-slate-50 via-blue-50 to-indigo-50 dark:from-slate-800 dark:via-slate-800 dark:to-indigo-900/30 border! border-slate-200 dark:border-slate-700 shadow-md!'
        ">
        <template #content>
            <div class="flex items-center justify-between mb-4">
                <div class="flex items-center space-x-3">
                    <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-200">{{ text }}</h3>
                </div>
                <div class="text-right">
                    <div class="flex items-center space-x-2">
                        <span class="text-sm text-slate-500 dark:text-slate-400 line-through"
                            v-if="levelUpdate.oldLevel !== levelUpdate.newLevel">
                            {{ $t("level") }} {{ levelUpdate.oldLevel }}
                        </span>
                        <span class="text-xl font-bold"
                            :class="levelUpdate.oldLevel !== levelUpdate.newLevel ? 'text-blue-600 dark:text-blue-400' : 'text-slate-700 dark:text-slate-300'">
                            {{ $t("level") }} {{ levelUpdate.newLevel }}
                        </span>
                        <Tag v-if="levelUpdate.oldLevel !== levelUpdate.newLevel"
                            class="text-xs bg-blue-100 text-blue-700 dark:bg-blue-800 dark:text-blue-200 px-2 py-1 rounded-full font-medium animate-pulse"
                            :value="$t('new') + '!'" rounded />
                    </div>
                </div>
            </div>

            <!-- XP Progress Bar -->
            <LevelUpdate :levelUpdate="levelUpdate" :showAnimation="showAnimation" />
        </template>
    </Card>
</template>

<script setup lang="ts">
import type { LevelUpdateDto } from "@/client";
import LevelUpdate from "./LevelUpdate.vue";

const props = defineProps<{
    levelUpdate: LevelUpdateDto;
    showAnimation: boolean;
    text: string;
}>();
</script>